<script>
// import Vue from 'vue'
import Vue from 'vue'
import UserService from '../../services/user'
import Store from '../../services/lstorage'
import toast from 'vue-material-components'
// import BoardVisor from './boardVisor'
// import BoardVisorSmall from './boardVisorSmall'
// import UploadFiles from './uploadFiles'
// import BodyMen from './bodyMen'
// import Jquery from 'jquery'

// var intervalTorneos1 = null
// var intervalTorneos2 = null
// var userClub = []
var stylesBoard = {
  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
}

export default {
  route: {
    canActivate: function (transition) {
      return UserService.user_acces('authenticate') ? true : transition.redirect('user/loguin')
    }
  },
  template: require('./template.html'),
  data () {
    return {
      finduser: '',
      bGuardar: false,
      sendToAll: false,
      dirActionUpload: Store.get('serverDir') + '/chat/upload',
      dirServer: Store.get('serverDir'),
      filesUpload: [],
      hashFileBoard1: '',
      hashFileBoard2: '',
      hashFileBoard3: '',
      fileProgress: 0,
      allFilesUploaded: true,
      offcanvas: false,
      active: 'boardVisor',
      tab: '0',
      tabs: [],
      chattext: '',
      user: UserService.user,
      boards: [],
      boardFiles: [],
      boardFilesName: '',
      boardFiles2: [],
      boardFilesName2: '',
      boardFiles3: [],
      boardFilesName3: '',
      rondas: 1,
      rondaactual: 1,
      nombretorneo: 'Torneo 1',
      newboard: {
        color: 'w',
        time: '3',
        incremento: 0,
        elo: 1500,
        contrincante: '',
        public: true,
        broadcast: false,
        all: false,
        club: ''
      },
      todosCheck: false,
      users: [],
      players: [],
      round1: {
        rounds: []
      },
      bSimultanea: true,
      bRandColor: false,
      usersLength: 0,
      games: [],
      board: Store.get('boardSee', {}),
      stylesBoard: stylesBoard,
      styles: Store.get('styleBoard',
        {
          board: 0,
          pieces: 0
        }),
      classBoard: ''
      // userClubData: {}
    }
  },
  mixins: [
    toast
  ],
  watch: {
  },
  events: {
    users (data) {
      this.users = data.nicknames
      // window.alert(JSON.stringify(this.boards[0]))
      // this.getTorneos(1)
      // this.getTorneos(2)
      var playersParam = {}
      for (var i in this.users) {
        if (this.users[i].club === this.user.club) {
          var nombre = this.users[i].nickname
          playersParam[nombre] = { name: nombre, juega: true, user: i }
        }
      }
      playersParam['PC'] = { name: 'PC', juega: false, user: null }
      this.players = playersParam
    },
    boards (data) {
      this.boards = data.boards
    },
    mensaje (data) {
      this.recibeMensaje(data.men, true, true)
      if (data.men.send !== this.user.username) {
        this.chatRecibido = true
      }
    },
    updateBoards (classBoard) {
      this.classBoard = classBoard
    }
  },
  props: {},
  computed: {},
  components: {
    // BoardVisor,
    // UploadFiles,
    // BodyMen
    // BoardVisorSmall
  },
  methods: {
    createAllTournament () {
      this.round1 = {}
      for (var x = 0; x < this.rondas; x++) {
        this.createTournament(x)
      }
      this.bGuardar = true
    },
    recibeMensaje (men, bottom = false, toast = true) {
      // var idDiv = 'chatConvertGame'
      // var divScroll = document.getElementById(idDiv)
      // var atBottom = divScroll.scrollTop >= divScroll.scrollHeight - divScroll.clientHeight
      // window.alert(JSON.stringify(men))
      if (men.board === 'Retransmisión') {
        // window.alert(JSON.stringify(men))
        this.mensjGame.push(men)
        if (bottom) {
          this.isAtBottom()
        }
      }
      if (toast === true) {
        if (men.send !== UserService.getUser().username) {
          this.toast('<span>' + men.send + ': ' + men.body + '</span>', 1000)
        }
      }
    },
    roundRobin (teams) {
      let schedule = []
      let league = []
      var rondaRoundRobin = {}
      for (var i in this.players) {
        if (this.players[i].juega === true) {
          league.push(this.players[i].name)
        }
      }
      // var league = teams// .slice()
      if (league.length % 2) {
        league.push('None')
      }
      let rounds = league.length
      // window.alert(rounds)
      this.rondas = rounds
      for (var j = 0; j < (rounds - 1) * 2; j++) {
        schedule[j] = []
        var round = {}
        for (let i = 0; i < rounds / 2; i++) {
          // var partidas = 0
          // window.alert(JSON.stringify(league[i]))
          if (league[i] !== 'None' && league[rounds - 1 - i] !== 'None') {
            var white = ''
            var black = ''
            if (j % 2 === 1) {
              schedule[j].push([league[i], league[rounds - 1 - i]])
              white = league[i]
              black = league[rounds - 1 - i]
            } else {
              schedule[j].push([league[rounds - 1 - i], league[i]])
              white = league[rounds - 1 - i]
              black = league[i]
            }
            var partida = {white: white, black: black}
            round[i] = partida
            // partidas++
          }
        }
        // window.alert(j)
        var roundaux = { rounds: round }
        rondaRoundRobin[j] = roundaux
        league.splice(1, 0, league.pop())
      }

      if (this.players['PC'] === undefined) {
        this.players['PC'] = { name: 'PC', juega: false, user: null }
      }
      this.round1 = rondaRoundRobin

      // window.alert(JSON.stringify(schedule))
      return schedule
    },
    saveTournament () {
    },
    createRoundRobin () {
      this.shuffleVueArray(this.players)
      this.roundRobin(this.players)
      this.bGuardar = true
    },
    createTournament (ronda) {
      // var mensaje = 'rondas: ' + this.rondas + ' tiempo: ' + this.newboard.time + ' inc: ' + this.newboard.incremento
      // window.alert(ronda)
      var jugadores = ''
      var partidas = 0
      var white = ''
      var black = ''
      var round = {}
      this.shuffleVueArray(this.players)
      for (var i in this.players) {
        if (this.players[i].juega === true) {
          jugadores += '(' + i + ') ' + this.players[i].name + ': ' + this.players[i].juega + '\n'
          if (this.bSimultanea === true) {
            if (UserService.getUser().username !== this.players[i].name) {
              if (this.bRandColor === true && ((Math.random() * 10) > 4)) {
                black = UserService.getUser().username
                white = this.players[i].name
              } else {
                white = UserService.getUser().username
                black = this.players[i].name
              }
              var partida = {white: white, black: black}
              round[partidas] = partida
            }
          } else {
            if (partidas % 2 === 0) {
              white = this.players[i].name
            } else {
              black = this.players[i].name
              partida = {white: white, black: black}
              round[partidas] = partida
            }
          }
          partidas++
        }
      }
      if (this.players['PC'] === undefined) {
        this.players['PC'] = { name: 'PC', juega: false, user: null }
      }
      // window.alert('Creando el torneo: ' + mensaje + '\n' + 'Jugadores: \n' + jugadores)
      // window.alert(JSON.stringify(round))
      var roundaux = { rounds: round }
      this.round1[ronda] = roundaux
      // this.round1[ronda].rounds = round
      // this.createdInviteGame(white, black)
    },
    shuffleVueArray (arrayParam) {
      var array = []
      var index = 0
      for (var ii in arrayParam) {
        array.push(arrayParam[ii].name)
        index++
      }
      for (let i = this.getLength(array) - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        const temp = array[i]
        Vue.set(array, i, array[j])
        Vue.set(array, j, temp)
        const temp2 = arrayParam[array[i]]
        Vue.set(arrayParam, array[i], arrayParam[array[j]])
        Vue.set(arrayParam, array[j], temp2)
      }
    },
    createInvites (rondaParam) {
      this.rondaactual = rondaParam - 1
      var _self = this
      window.swal('¿Desea lanzar partidas de la ronda ' + (this.rondaactual + 1) + '?', {
        buttons: {
          si: {text: 'Sí', value: 's'},
          no: {text: 'No', value: 'n'}
        }
      }).then(function (resultParam) {
        // window.alert(resultParam)
        if (resultParam === 's') {
          // window.alert(JSON.stringify(this.round1))
          var rondaInvites = _self.round1[_self.rondaactual]
          for (var i in rondaInvites.rounds) {
            _self.createdInviteGame(rondaInvites.rounds[i].white, rondaInvites.rounds[i].black)
          }
        }
      })
      /* if (window.confirm('¿Desea lanzar partidas de la ronda ' + (this.rondaactual + 1) + '?')) {
        // window.alert(JSON.stringify(this.round1))
        var rondaInvites = this.round1[this.rondaactual]
        for (var i in rondaInvites.rounds) {
          this.createdInviteGame(rondaInvites.rounds[i].white, rondaInvites.rounds[i].black)
        }
      }*/
    },
    createdInviteGame (userNameWhite, userNameBlack) {
      // var userWhite = this.players[userNameWhite].user
      // var userBlack = this.players[userNameBlack].user
      var invite = {
        type: 'invite',
        public: this.newboard.public,
        broadcast: false,
        all: false,
        vsPc: false,
        torneo: this.nombretorneo,
        ronda: this.rondaactual,
        confirm: false,
        club: UserService.getUser().club,
        time: this.newboard.time,
        incremento: this.newboard.incremento,
        recibe: this.active,
        elo: UserService.getUser().elo
      }
      if (userNameWhite === 'PC') {
        invite.vsPc = true
        invite.confirm = true
        // window.alert(this.newboard.elo)
        invite.elo = this.newboard.elo
      }
      // var userActive = userNameWhite
      // UserService.setUser(userActive)
      // var bFound = false
      if (userNameBlack !== '') {
        invite.confirm = true
        if (userNameBlack === 'PC') {
          invite.vsPc = true
          invite.elo = this.newboard.elo
          // userActive = 'PC'
          // bFound = true
        }
        /* else {
          for (var i in this.users) {
            if (this.users[i].nickname === userNameBlack) {
              userActive = this.users[i].nickname
              bFound = true
              alert(userActive)
            }
          }
        }*/
        /* if (bFound === false) {
          // window.alert('error')
          // this.$broadcast('modal::close', 'some', 'inviteGame')
          return
        }*/
      }
      if (this.newboard.color === 'w') {
        invite.u1 = userNameWhite
        invite.u2 = userNameBlack
      } else {
        invite.u2 = userNameWhite
        invite.u1 = userNameBlack
      }
      /* var data = {
        c: 'board',
        f: 'inviteGame',
        data: {
          event: 'inviteGame',
          data: invite
        }
      }*/
   // JSON.stringify(invite))
      if (invite.confirm === true) {
        this.InviteGameActionConfirmado(invite)
      }
    },
    InviteGameActionConfirmado (invite) {
      // preparar tablero
      var data = {
        c: 'board',
        f: 'confirmGame',
        data: invite
      }
      // window.alert('InviteGameActionConfirmado' + JSON.stringify(invite))
      if (invite.confirm || invite.vsPc) {
        data.f = 'addBoard'
        // this.deleteInvite(invite)
      } else {
        // this.toast('<span>Esperando confirmacion de usuario</span>', 2000, 'rounded')
      }
      this.$socket.emit('event', data, function (...callbacks) {
        if (callbacks[0]) {
        // window.alert(callbacks[0])
        }
      })
      // this.deleteInvite(invite)
      // eliminar invitacion del arreglo
    },
    getLength (param) {
      var ret = 0
      if (param !== undefined && Object.keys(param) !== undefined) {
        ret = Object.keys(param).length
      }
      return ret
    },
    imageUrlAlt (event) {
      event.target.src = '../../../static/images/50x50defaultAvatar.png'
    },
    imageUrl (name) {
      return this.dirServer + '/uploads/' + name
    },
    loadAllData () {
      var data = {
        c: 'chat',
        f: 'getDataChat',
        data: {
          user: UserService.getUser()
        }
      }
      const showSocketError = (context = '') => {
        console.error('Socket desconectado error')
      }
      const maxRetries = 10
      const retryDelay = 500 // milisegundos
      let attempt = 1
      const tryEmit = () => {
        const socket = this.$socket

        if (socket && socket.connected) {
          socket.emit('event', data, (...callbacks) => {
            /* var logUser = callbacks[1].logUser
            for (var i = 0; i < logUser.length; i++) {
              if (logUser[i]) {
                // this.openTab({nickname: logUser[i]}, false)
                /* var parmsLoad = {
                  user: logUser[i],
                  range: {
                    limit: 30,
                    skip: 0
                  }
                }
                // this.loadUserConvert(parmsLoad)
              }
            }*/
            // this.loadUserClubData(callbacks[1].boards)
            this.boards = callbacks[1].boards
            console.log('USERLOGUINSOCKET:', callbacks[1])
          })
        } else {
          if (attempt <= maxRetries) {
            console.warn(`userLoguinSocket: intento ${attempt}/${maxRetries} - socket no conectado`)
            attempt++
            setTimeout(tryEmit, retryDelay)
          } else {
            showSocketError('userLoguinSocket: No se pudo conectar después de varios intentos')
          }
        }
      }

      tryEmit()
    },
    loadUserConvert (parms, historyTop = false) {
      var data = {
        c: 'chat',
        f: 'loadUserConvert',
        data: parms
      }
      this.$socket.emit('event', data, function (...callbacks) {
        var log = callbacks[1]
        /* if (historyTop) {
          // adiciona mensajes al principio de la conversacion
          var post = this.foundTab(this.active)
          if (log.length > 0) {
            Jquery('#content_' + this.active).animate({
              'scrollTop': 100
            }, 'slow')
          }
          var menHistory = log.concat(this.tabs[post].men)
          this.tabs[post].men = menHistory
        } else {*/
        // Recoger todos los mensajes antiguos
        const isToday = (someDate) => {
          const today = new Date()
          return someDate.getDate() === today.getDate() &&
            someDate.getMonth() === today.getMonth() &&
            someDate.getFullYear() === today.getFullYear()
        }
        var menLast = ''
        if (log) {
          for (var i = log.length - 1; i >= 0; i--) {
            if (menLast !== log[i].body && isToday(new Date(log[i].created)) && log[i].board === this.board._id) {
              this.recibeMensaje(log[i], true, false)
              menLast = log[i].body
            }
          }
        }
        // }
      }.bind(this))
    }
  },
  attached () {
    /* setTimeout(function () {
      this.active = 'boardVisor'
      this.loadAllData()
      // window.alert(JSON.stringify(this.boards[0]))
      // this.getTorneos(1)
      // this.getTorneos(2)
    }.bind(this), 100)
    this.$dispatch('userLoguin', 'show data')
    setTimeout(function () {
      this.showBoard()
    }.bind(this, 1000))*/
  },
  ready () {
    /* let pgnvjs = document.createElement('script')
    pgnvjs.setAttribute('src', '../../../static/dist/js/pgnvjs.min.js')
    document.head.appendChild(pgnvjs)
    let simplechessboard = document.createElement('script')
    simplechessboard.setAttribute('src', '../../../static/libs/simplechessboard.min.js')
    document.head.appendChild(simplechessboard)*/
    document.title = 'Mainchess - ' + this.$t('tournament.title')
  },
  created () {
    this.classBoard = this.stylesBoard['board'][this.styles['board']] + ' chessground vuejs ' + this.stylesBoard['pieces'][this.styles['pieces']]
    this.$nextTick(function () {
      this.active = 'boardVisor'
      this.loadAllData()
    })
    this.$dispatch('userLoguin', 'show data')
    this.bGuardar = false
    /* this.$nextTick(function () {
      this.showBoard()
    })*/
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?c779ab68